// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + (chunkId === 8792 ? "main" : chunkId) + "." + {"6427":"7607890b0b19554d49cd","8792":"97f8c4b433968f919c49"}[chunkId] + ".css";
};